import {
  PROPOSE_TASK_DELETE, PROPOSE_TASK_DELETE_FAILURE, PROPOSE_TASK_DELETE_SUCCESS
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    [PROPOSE_TASK_DELETE] ({dispatch, state, commit}, params) {
      const url = `/master/propose_tasks/${params.id}`
      let data = {}
      let callback = null
      data = params.data
      params.callback && (callback = params.callback)
      dispatch('apiDelete', {url: url, data: data, callback: callback})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_TASK_DELETE_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(PROPOSE_TASK_DELETE_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [PROPOSE_TASK_DELETE_FAILURE] (state, data) {
      console.log('PROPOSE_TASK_DELETE_FAILURE')
    },
    [PROPOSE_TASK_DELETE_SUCCESS] (state, data) {
      console.log('PROPOSE_TASK_DELETE_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/propose-task-delete.js